/* eslint-disable react/no-danger */

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles({
  resetFontSize: {
    fontSize: '1rem',
  },
  root: {
    '& ol': {
      listStyleType: 'decimal',
    },
    '& p': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& ol ol': {
      listStyleType: 'lower-alpha',
    },
    '& ol ol ol': {
      listStyleType: 'lower-roman',
    },
    overflowWrap: 'anywhere',
  },
  noWrap: {
    overflowWrap: 'unset',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

/** @deprecated Import RichTextDisplay from FacetDesign/Components
 */
const RichTextDisplay = React.forwardRef((props, ref) => {
  const {
    content, className, noWrap, resetFontSize, setOnRef, ...rest
  } = props;

  const classes = useStyles();
  const theme = useTheme();
  const selfRef = useRef(null);
  if (setOnRef && selfRef) {
    setOnRef(selfRef.current);
  }

  return (
    <>
      <div
        test="rich-text-display"
        dangerouslySetInnerHTML={{ __html: content }}
        ref={ref || selfRef}
        className={classNames(classes.root, {
          [classes.resetFontSize]: resetFontSize,
          [classes.noWrap]: Boolean(noWrap),
          [className]: Boolean(className),
        })}
        {...rest}
      />
      {/* This style tag overrides synced email formatting and make them look presentable. */}
      {/* We have to use a style tag like this because the RichTextDisplay lives in a ShadowDOM when displaying emails. */}
      <style>
        {`
          .gmail_quote, .protonmail_quote {
            color: ${theme.palette.facet.accentPurple};
            margin-left: ${theme.spacing(0.5)}px;
            font-size: 11px;
            width: fit-content;
          }
          blockquote {
            color: ${theme.palette.facet.accentPurple};
            font-size: 11px;
            border-left: 1px solid ${theme.palette.facet.mediumGray};
            padding-left: ${theme.spacing(0.5)}px;
            margin-inline: 0;
            margin-block: 0;
          }
          img {
            max-width: 100%;
          }
          b {
            font-weight: bold;
          }
        `}
      </style>
    </>
  );
});

RichTextDisplay.propTypes = {
  content: PropTypes.string,
  className: PropTypes.string,
  noWrap: PropTypes.bool,
  resetFontSize: PropTypes.bool,
  setOnRef: PropTypes.func,
};
RichTextDisplay.defaultProps = {
  content: '',
  className: undefined,
  noWrap: false,
  resetFontSize: true,
  setOnRef: null,
};

export default RichTextDisplay;
export const RichTextDisplayField = ({ value, ...rest }) => <RichTextDisplay content={value} {...rest} />;
